import { useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { EditPage, EditPagePanel, EditPageTextField, EditPageCheckbox } from '../../../../common/EditPage';
import { useParams, useNavigate } from 'react-router-dom';
import { getOne, update } from '../../../../common/v4/BackendProvider';
import { toast } from 'react-toastify';

const AccessRightsEdit = () => {
    const [data, setData] = useState({});
    const [metadata, setMetadata] = useState({});
    const navigate = useNavigate();
    const { rightId } = useParams();
    
    useEffect(() => {
        getOne(`/admin/access/rights/`, rightId).then(response => {
            setMetadata(response.data.metadata);
            setData(response.data.data);
        }).catch(error => {
            toast.error("Error fetching access right: " + error.message, {});
        });
    }, [rightId]);

    const handleSave = () => {
        update(`/admin/access/rights/`, rightId, {data: data}).then(() => {
            navigate(`/admin/access/rights`);
        }).catch(error => {
            toast.error("Error updating access right: " + error.message, {});
        });
    };

    const handleCancel = () => {
        navigate(`/admin/access/rights`);
    };

    const onChange = (id, value) => {
        setData({...data, [id]: value});
    };

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <EditPage handleSave={handleSave} handleCancel={handleCancel}>
                <EditPagePanel>
                    <EditPageTextField 
                        label="Access Group" 
                        id="access_group_name" 
                        value={data.access_group?.name || ''} 
                        disabled
                    />
                    <EditPageTextField 
                        label="Access Area" 
                        id="access_area_name" 
                        value={data.access_area?.name || ''} 
                        disabled
                    />
                    <EditPageCheckbox 
                        label="Can Read" 
                        id="can_read" 
                        onChange={onChange} 
                        value={data.can_read}
                    />
                    <EditPageCheckbox 
                        label="Can Write" 
                        id="can_write" 
                        onChange={onChange} 
                        value={data.can_write}
                    />
                </EditPagePanel>
            </EditPage>
        </>
    )
}

export default AccessRightsEdit; 